import { createSlice } from '@reduxjs/toolkit';

// Create a slice for dev mode settings
const devModeSlice = createSlice({
  name: 'devMode',
  initialState: {
    enabled: false,
  },
  reducers: {
    enableDevMode: (state) => {
      state.enabled = true;
      sessionStorage.setItem('devMode', 'true');
    },
    disableDevMode: (state) => {
      state.enabled = false;
      sessionStorage.setItem('devMode', 'false');
    },
  },
});

// Export actions and reducer
export const { enableDevMode, disableDevMode } = devModeSlice.actions;
export default devModeSlice.reducer;
